import { Drawer, Descriptions } from "antd"
import React, { useState } from "react"
import moment from "moment"

export default function OrderTimestampsDrawer({ order, children }) {
  const [drawerVisible, setDrawerVisible] = useState(false)

  if (!order) return null

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "—"

    if (timestamp.seconds) {
      return moment.unix(timestamp.seconds).format("DD.MM.YYYY HH:mm:ss")
    }

    if (timestamp instanceof Date) {
      return moment(timestamp).format("DD.MM.YYYY HH:mm:ss")
    }

    if (typeof timestamp === "string") {
      return moment(timestamp).format("DD.MM.YYYY HH:mm:ss")
    }

    return "—"
  }

  return (
    <>
      <div onClick={() => setDrawerVisible(true)} style={{ cursor: "pointer" }}>
        {children}
      </div>

      <Drawer
        title="Order Timestamps"
        placement="right"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width={400}>
        <Descriptions column={1} layout="vertical" bordered size="small">
          <Descriptions.Item label="Created">
            {formatTimestamp(order.created)}
          </Descriptions.Item>
          <Descriptions.Item label="Done by Machine">
            {formatTimestamp(order.doneByMachine)}
          </Descriptions.Item>
          <Descriptions.Item label="Done by Winder">
            {formatTimestamp(order.doneByRewinder)}
          </Descriptions.Item>
        </Descriptions>
      </Drawer>
    </>
  )
}
